import {
  CONFIGURATION_DATA_DEFAULT_BODY,
  CONFIGURATION_DEFAULT_BODY,
  SELECTED_CONFIGURATION_DEFAULT_BODY,
} from '@/constants/crm/_shared/configuration';
import { DEFAULT_CRM_SYSTEM } from '@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen';
import { Tables } from '@/lib/supabase/supabase_types_override';
import { DEFAULT_CONFIGURATION_FOR_CRM_SYSTEM } from '@/lib/utils/crm/defaultConfiguration';

export function populateDefaultValuesForCrm<
  T extends Partial<Pick<
    Tables<'crm'>,
    | 'default_configuration'
    | 'configuration'
    | 'configuration_data'
    | 'selected_configuration'
    | 'crm_system'
  >>
>(data: T): T {
  return {
    ...data,
    default_configuration:
      data.default_configuration ??
      DEFAULT_CONFIGURATION_FOR_CRM_SYSTEM[
        data?.crm_system ?? DEFAULT_CRM_SYSTEM
      ],
    configuration: data.configuration ?? CONFIGURATION_DEFAULT_BODY,
    configuration_data:
      data.configuration_data ?? CONFIGURATION_DATA_DEFAULT_BODY,
    selected_configuration:
      data.selected_configuration ?? SELECTED_CONFIGURATION_DEFAULT_BODY,
    crm_system: data?.crm_system ?? DEFAULT_CRM_SYSTEM,
  };
}
